module.exports = __webpack_public_path__ + "img/favicon.5666a87.png";